<template>
  <div class="molded" :style="moldedStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Molded",
  props: {
    borderRadius: {
      type: Number,
      default: 6,
    },
    paddingTop: {
      type: Number,
      default: 15,
    },
    paddingRight: {
      type: Number,
      default: 30,
    },
    paddingBottom: {
      type: Number,
      default: 10,
    },
    paddingLeft: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    moldedStyle() {
      return {
        borderRadius: this.borderRadius + "px",
        paddingTop: this.paddingTop + "px",
        paddingRight: this.paddingRight + "px",
        paddingBottom: this.paddingBottom + "px",
        paddingLeft: this.paddingLeft + "px",
      };
    },
  },
};
</script>
<style scoped>
.molded {
  border: 1px solid #e8eaed;
  background-color: white;
  border-radius: 10px !important;
  box-shadow: 0px 10px 100px -6px rgb(0 0 0 / 5%);
}
</style>
